import { type FieldCodec, setOf } from '~/models/filterCodec'

/**
 * 保存フィルタの `ReadonlySet` の項目 (JSON 上は配列)。 スポットの絞り込みの型は `ReadonlySet` で
 * 持つ (一覧の判定関数が書き換えない) ので、 `setOf` を `ReadonlySet` の項目として宣言できるようにする。
 */
export function readonlySetOf<T>(
  item: FieldCodec<T>,
): FieldCodec<ReadonlySet<T>> {
  const set = setOf(item)
  return { encode: (value) => set.encode(new Set(value)), decode: set.decode }
}
